"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InlineQuoteRenderer_1 = require("../../components/InlineQuoteRenderer");
var _globals_1 = require("../_globals");
new InlineQuoteRenderer_1.InlineQuoteRenderer(_globals_1.root);
